import { AreaApi } from "../../../../Shared/Constants/api";

import axiosInstance from "../../../../Shared/Utils/axiosInstance";

import { getAreaCreationObject } from "../Data/AreaWrappers";

export const updateAreaApi = async (data, id) => {
  try {
    let response = await axiosInstance.put(
      `${AreaApi}/${id}`,
      getAreaCreationObject(data)
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further Area if needed
  }
};
